import React, { Component, useEffect, useState } from 'react';
import styled from 'styled-components';
import Slider from "react-slick";
import { Link } from "react-router-dom";
// import {color} from '../../sass-files/variable.js';
// import videobg from '../../../images/video_background.png';
// import config from 'src/config/config';
// import {  theme } from 'styled-tools';
import redplaybutton from '../../../images/redplaybtn.png';
// import VideoFirst from '../../../images/live_stream_teenpatti.png';
// import VideoSecond from '../../../images/live_stream_jackpot.png';
import next from '../../../images/video_next.png';
import prev from '../../../images/video_prev.png';
import MyCustomComponent from './video';
import sample from 'lodash/sample';
import { withAppContext } from 'src/store/initAppContext';
// const {menucolor} = color

function VideoBannerSlider(props) {
    const [randDomUrl, setRandomUrl] = useState('')
    useEffect(() => {
        getRandomUrl()
    }, [])
    const getRandomUrl = () => {
        switch (props.app.brandId) {
            case 31:
                let yoloVideo = [
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/yolo-video3.mp4',
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/yolo-video2.mp4',
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/yolo-video1.mp4'
                ]
                let yoloUrl = sample(yoloVideo);
                setRandomUrl(yoloUrl)
                break;
            case 32:
                let yoloClubVideo = [
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/yolo-video3.mp4',
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/club-video1.mp4',
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/yolo-video3.mp4',
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/club-video1.mp4'
                ]
                let yoloClubUrl = sample(yoloClubVideo);
                setRandomUrl(yoloClubUrl)
                break;
            case 33:
                let baaziaddaVideo = [
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/IW247.mp4'
                ]
                let baaziaddaUrl = sample(baaziaddaVideo);
                setRandomUrl(baaziaddaUrl)
                break;
            case 34:
                let betdailyClubVideo = [
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/Betdaily-club-video1.mp4',
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/Betdaily-club-video1.mp4',
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/Betdaily-club-video1.mp4',
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/Betdaily-club-video1.mp4',
                ]
                let betdailyClulubUrl = sample(betdailyClubVideo);
                setRandomUrl(betdailyClulubUrl)
                break;
            case 39:
                let fomoVideo = [
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/Fomo7-video1.mp4'
                ]
                let fomoUrl = sample(fomoVideo);
                setRandomUrl(fomoUrl)
                break;
            case 40:
                let fomoClubVideo = [
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/Fomo7-video1.mp4'
                ]
                let fomoClubUrl = sample(fomoClubVideo);
                setRandomUrl(fomoClubUrl)
                break;
            case 46:
                let fun88ClubVideo = [
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/fun88-video1.mp4'
                ]
                let fun88ClubUrl = sample(fun88ClubVideo);
                setRandomUrl(fun88ClubUrl)
                break;
            case 47:
                let fun88ComVideo = [
                    'https://website-videostream.s3.eu-west-1.amazonaws.com/fun88-video1.mp4'
                ]
                let fun88ComUrl = sample(fun88ComVideo);
                setRandomUrl(fun88ComUrl)
                break;
            default:
                setRandomUrl('');
        }
    }
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // autoplay: true,
        arrows: true,
        pauseOnHover: true,
    };

    return (
        <VideoBannerWrapper>
            <Slider {...settings}>
                <div>
                    <Link className="banner_img" to="/">
                        <MyCustomComponent src={randDomUrl} height='60%' />
                    </Link>
                </div>
            </Slider>
        </VideoBannerWrapper>
    )
}

export default withAppContext(VideoBannerSlider);

const VideoBannerWrapper = styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    // height: 520px;
    width: 32%;
    height: 100%;
    padding: 0px 20px;
    top: -3px;
    right: 0;

    a {
        // padding: 35px;
        position: relative;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        
        video {
            // padding: 0px;
            // padding: 50px;
			// border-radius: 20px;
			position: static;
			transform: unset;
            // object-fit: contain;
            object-fit: cover;
            // width: 100%;
            border-radius: 85px 0px;
            border: none;
            // width: 100%;
            // height: 262px;
            width: 100%;
            min-height: 260px;
            height: 100%;
            -webkit-box-shadow: 0px 0px 14px 7px rgba(0,0,0,0.11); 
            box-shadow: 0px 0px 14px 7px rgba(0,0,0,0.11);
            border: 1px solid;
            border-image-source: linear-gradient(180deg, #939393 0%, rgba(255, 187, 7, 0) 100%);

            @media (min-width: 1800px) {
                min-height: 330px;
            }
        }
    }

    .slick-slider .slick-prev {
        left: 90px;
        top: auto;
        bottom: -39px;
        z-index: 99;
    }

    .slick-slider .slick-next {
        right: 97px;
        top: auto;
        bottom: -39px;
        z-index: 99;
    }

    .slick-prev:before {
        font-family: 'slick';
        font-size: 20px;
        line-height: 1;
        opacity: unset;
        color: transparent;
        width: 8px;
        height: 15px;
        display: inline-block;
        background-image: url(${prev});
        background-size: cover;
        background-repeat: no-repeat;
    }

    .slick-next:before {
        font-family: 'slick';
        font-size: 20px;
        line-height: 1;
        opacity: unset;
        color: transparent;
        width: 8px;
        height: 15px;
        display: inline-block;
        background-image: url(${next});
        background-size: cover;
        background-repeat: no-repeat;
    }

    .slick-slider .slick-dots > li {
        width: auto;
        height: auto;
		display: inline-block;
		vertical-align: middle;
        margin: 0;
        margin-left: -5px;
	}

	.slick-slider .slick-dots > li > button {
		display: block;
		width: 130px;
		height: 5px;
		background: rgba(255, 255, 255, 0.6);
		font-size: 0;
		border: none;
		outline: none;
        border-radius: 5px;
        padding: 4px;
    }
    
    .slick-dots {
        // bottom: 5px;
        li button:before {
            font-size: 0;
            display: none;
        }
    }

	.slick-slider .slick-dots > li.slick-active > button {
		background: #CB9640;
    }
    
    .slick-track {
        width: 100%!important;
    }

    .slick-slide {
        width: 100%!important;
    }
`;

const OverlappingText = styled.div`
	width: 100%;
	position: absolute;
	left: 0;
	top: 0;
	padding: 50px;
	padding-left: 70px;

	h4 {
		// font-size: 42px;
		font-size: 30px;
		letter-spacing: 0.05em;
		text-transform: uppercase;
		color: #fff;
		font-weight: bold;
		line-height: 30px;
		margin-bottom: 15px;
		// margin-top: 60px;
	}

	p {
		display: flex;
		align-items: center;
		color: #FFC907;
		font-size: 16px;
		letter-spacing: 0.05em;
		text-transform: uppercase;
		font-weight: 500;
		margin: 0;
    	margin-bottom: 25px;
	}

	p:before {
		content: "";
		width: 20px;
		height: 20px;
    	margin-right: 5px;
		background-size: contain;
        background-image: url(${redplaybutton});
	}

	button {
		// width: 189.17px;
		// height: 56.75px;
		width: 149px;
		height: 36px;
		display: flex;
		align-items: center;
        background: linear-gradient(180deg, #D7AE6D 0%, #DEC59D 100%);
		border-radius: 3px;
		color: #FFFFFF;
		letter-spacing: 0.05em;
		text-transform: uppercase;
		justify-content: center;
		border: none;
		cursor: pointer;
	}
`;